import { DateRange } from "./DateRange";
import { dateRangeToFullWeeks } from "./dateRangeToFullWeeks";
import { eachUtcDayWithinRange } from "./eachUtcDayWithinRange";

export const getDateRange = (start: Date, end: Date): DateRange => {
  const days = eachUtcDayWithinRange({ start, end });
  const weeks = dateRangeToFullWeeks(start, end);

  return {
    days,
    weeks,
  };
};
